/** @format */

import React, { FunctionComponent } from 'react';
import I18n from '../Translate/I18n';
import { FilterListItem } from './FilterListItem';

const _ = require('underscore');

type FilterListItemProps = {
    filters: Array<{ elementName: string; columnName: string; value: any; elementHasValue: boolean }>;
    header: string;
};

export const FilterListItemsWrapper: FunctionComponent<FilterListItemProps> = ({ filters, header }) => (
    <div style={{  marginTop: '20px' }}>
        <div style={{ display: 'inline-block', width: 'fit-content', marginRight: '15px' }}>
            <I18n trans={header} />:
        </div>

        {filters.map((item: any) => {
            if (Array.isArray(item.value)) {
                return item.value.map((subitem: any) => {
                    let tmpVal = subitem;
                    if (typeof tmpVal === 'string' && tmpVal === 'null') {
                        tmpVal = item.overwriteValueDisplay;
                    }
                    return <FilterListItem key={item.elementName + subitem} item={item} value={tmpVal} />;
                });
            } else {
                let tmpVal = item.value;
                if (typeof tmpVal === 'string' && tmpVal === 'null') {
                    tmpVal = item.overwriteValueDisplay;
                }
                return <FilterListItem key={item.elementName} item={item} value={tmpVal} />;
            }
        })}
    </div>
);
